<template>
  <o-view class="c-view--poi" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        :has-back-button="true"
        :is-centered="true"
        :is-extended="true"
        logo="brands-q8"
      >
        <template slot="right">
          <o-icon icon="favorite" v-if="$store.state.showFavoriteButton" />
        </template>
      </o-nav-bar>
      <div class="c-view--poi-sections">
        <o-section :is-transparent="true" :poi-header="true">
          <h2 class="c-poi-title">Q8 Brusselsesteenweg</h2>
        </o-section>
        <o-block-list>
          <o-section>
            <o-key-value label="Adres">
              <template #value>
                Brusselsesteenweg 100<br />
                3000 Leuven
              </template>
            </o-key-value>
          </o-section>
          <o-section>
            <o-key-value label="Brandstoffen">
              <template #value>
                Diesel<br />
                Benzine euro 95<br />
                Benzine euro 98<br />
                LPG
              </template>
            </o-key-value>
          </o-section>
        </o-block-list>
      </div>
    </o-view>
    <o-pay-button label="Tank bij dit station" to="/sales/fuel/q8/welcome" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
import OProminents from '@/components/OProminents.vue'
export default {
  name: 'POICambio',
  components: {
    OPayButton,
    OProminents
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.c-view--poi {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-view--poi-sections {
    flex: 1 0 auto;
  }
}

.c-poi-title {
  font-weight: 600;
  text-align: center;
}

.c-poi-available {
  color: #000;
  font-weight: 600;

  .c-icon {
    color: $primary-color;
    color: var(--primary-color);
  }
}
</style>
